import urls from "global/constants/UrlConstants";
import { getCallParams, makeCall } from "utils/service";

export const fetchRecipientDomains = async (
  page: number,
  rowsPerPage: number,
  fromDate: Date | string | null,
  toDate: Date | string | null,
  searchText: string
) => {
  const url = `${urls.GET_ALL_RECIPIENT}/page/${page}/limit/${rowsPerPage}/new`;
  const body = {
    searchText: searchText,
    dateRange: {
      fromDate: fromDate,
      toDate: toDate,
    },
    entitySorters: [],
  };

  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const fetchRecipientDomainsCount = async (
  fromDate: Date | string | null,
  toDate: Date | string | null,
  searchText: string
) => {
  const body = {
    searchText: searchText,
    dateRange: {
      fromDate: fromDate,
      toDate: toDate,
    },
    entitySorters: [],
  };
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.GET_ALL_RECIPIENT_COUNT, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const fetchFailedStats = async (
  page: number,
  rowsPerPage: number,
  fromDate: Date | string | null,
  toDate: Date | string | null,
  searchText: string,
  bonusCount: number,
  campaignCategory: string
) => {
  const url = `${urls.GET_ALL_FAILED_STATUS}/${campaignCategory}/${bonusCount}/page/${page}/limit/${rowsPerPage}/new`;
  const body = {
    searchText: searchText,
    dateRange: {
      fromDate: fromDate,
      toDate: toDate,
    },
    entitySorters: [],
  };
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const fetchFailedStatsCount = async (
  fromDate: Date | string | null,
  toDate: Date | string | null,
  searchText: string,
  bonusCount: any,
  campaignCategory: any
) => {
  const body = {
    searchText: searchText,
    dateRange: {
      fromDate: fromDate,
      toDate: toDate,
    },
    entitySorters: [],
  };
  try {
    const url = `${urls.GET_ALL_FAILED_STATUS_COUNT}/${campaignCategory}/${bonusCount}/count/new`;
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const GetFailBouncedName = async () => {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(urls.GET_FAILED_BONUS_NAME, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};
